import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from 'react';
const UIContext = createContext({
    notify: ({ type, contents }) => { },
    notifyStore: {
        type: 'FAILURE',
        contents: "init"
    },
    modal: ({ title, contents, buttons }) => { },
    modalClose: () => { },
    modalStore: {
        title: 'init',
        contents: 'contents',
        buttons: [
            {
                label: 'confirm',
                color: 'red',
                fn: () => { }
            }
        ],
        bgClose: false
    },
    moreDropdown: ({ title, contents, buttons }) => { },
    moreDropdownStore: {
        type: 'FAILURE',
        contents: "init"
    },
    /* eslint-enable @typescript-eslint/no-empty-function */
});
const UIContextProvider = ({ lng, children }) => {
    //console.log('[UIContextProvider] Init')
    const [notifyStore, setNotifyStore] = useState({
        type: 'FAILURE',
        contents: "init"
    });
    const [modalStore, setModalStore] = useState({
        title: 'init',
        contents: 'contents',
        buttons: [
            {
                label: 'cancel',
                color: 'red',
                fn: () => { }
            },
            {
                label: 'confirm',
                color: 'red',
                fn: () => { }
            }
        ],
        bgClose: false
    });
    const [moreDropdownStore, setMoreDropdownStore] = useState({
        title: 'init',
        contents: 'contents',
        buttons: [
            {
                label: 'cancel',
                color: 'red',
                fn: () => { }
            },
            {
                label: 'confirm',
                color: 'red',
                fn: () => { }
            }
        ]
    });
    const notify = ({ type, contents }) => {
        setNotifyStore({
            type,
            contents,
        });
    };
    const modal = ({ title, contents, buttons, bgClose }) => {
        setModalStore({
            title,
            contents,
            buttons,
            bgClose
        });
    };
    const modalClose = () => {
        setModalStore({
            title: "close",
            contents: null,
            buttons: null,
            bgClose: false
        });
    };
    const moreDropdown = ({ title, contents, buttons }) => {
        setMoreDropdownStore({
            title,
            contents,
            buttons
        });
    };
    useEffect(() => {
        console.log('[UIContextProvider] Effect');
    }, []);
    const value = {
        notifyStore,
        notify,
        modalStore,
        modal,
        modalClose,
        moreDropdownStore,
        moreDropdown
    };
    return (_jsx(UIContext.Provider, { value: value, children: children }));
};
export { UIContext, UIContextProvider };
